import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'shared-not-found',
  templateUrl: './not-found.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotFoundComponent {}
